import React from "react";
import { useLocation } from "react-router-dom";
import CallButton from "./CallButton";
import BackToTop from "./BackToTop";
import ScrollDownButton from "./ScrollDownButton";
import styles from "./FloatingButtons.module.css";

const FloatingButtons: React.FC = () => {
  const { pathname } = useLocation();
  const isProjectDetailsPage = pathname.startsWith("/projects/");

  return (
    <>
      <CallButton className={styles.callButton} />
      <BackToTop
        className={
          isProjectDetailsPage
            ? styles.backToTopWithScroll
            : styles.backToTopButton
        }
      />
      {isProjectDetailsPage && <ScrollDownButton className={styles.scrollDownButton} />}
    </>
  );
};

export default FloatingButtons;
